import { RootState } from 'store/store';

export const selectTechnologiesData = (state: RootState) => state.technologies.technologies;
export const selectTechnologiesRequestStatus = (state: RootState) => state.technologies.technologiesRequestStatus;
